<div class="yearly-statistics-table-container">
  <div class="table-header">
    <h2>
      @if (isSummaryTable) {
        {{ isKumMode ? 'KÜM' : 'CC' }} - Összesen ( {{ year }} ÖSSZESEN )
      } @else {
        {{ isKumMode ? 'KÜM' : 'CC' }}: {{ colleagueName }}
      }
    </h2>
  </div>

  @if (isLoading) {
    <div class="loading-indicator">
      <span>Adatok betöltése...</span>
    </div>
  }

  <div class="table-wrapper">
    <table class="yearly-table">
      <colgroup>
        <col class="metric-col-def">
        @for (column of columns; track $index) {
          <col [class]="column.type === 'quarter-summary' ? 'quarter-col-def' : column.type === 'yearly-summary' ? 'yearly-col-def' : 'month-col-def'">
        }
      </colgroup>
      <thead>
        <tr class="header-row">
          <th class="metric-name-header">{{ year }} ÖSSZESEN</th>
          @for (column of columns; track $index) {
            <th [class]="'col-header ' + getHeaderClass(column)">
              {{ column.label }}
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (metric of metrics; track $index; let metricIndex = $index) {
          <!-- Plan sor -->
          <tr class="plan-row">
            <td class="metric-name plan-label">{{ metric.name }} P</td>
            @for (column of columns; track $index) {
              <td [class]="'data-cell ' + getColumnClass(column)">
                {{ getColumnValue(metric, column, 'plan') }}
              </td>
            }
          </tr>

          <!-- Actual sor (T = Tény / A = Actual) -->
          <tr class="actual-row">
            <td class="metric-name actual-label">{{ metric.name }} A</td>
            @for (column of columns; track $index) {
              <td [class]="'data-cell ' + getColumnClass(column)">
                {{ getColumnValue(metric, column, 'actual') }}
              </td>
            }
          </tr>

          <!-- Százalék sor -->
          <tr class="percentage-row">
            <td class="metric-name percentage-label">%</td>
            @for (column of columns; track $index) {
              <td [class]="'data-cell percentage-cell ' + getColumnClass(column)">
                {{ getColumnPercentage(metric, column) }}
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
